<script setup lang="ts">
import type { GraphqlDatatableColumn } from '~/components/GqlDatatable.vue';

const colunas = [
  {
    key: 'compromisso',
    title: 'COMPROMISSO',
    width: 120,
  },
  {
    key: 'responsavel',
    title: 'RESPONSÁVEL',
    width: 120,
  },
  {
    dataIndex: 'dataInicioText',
    key: 'dataInicio',
    sortBy: ['dataInicio'],
    sorter: true,
    title: 'SOLICITADO EM',
    width: 120,
    defaultSortOrder: 'descend',
  },
  {
    dataIndex: 'dataConclusaoText',
    key: 'dataConclusao',
    sortBy: ['dataConclusao'],
    sorter: true,
    title: 'CONCLUÍDO EM',
    width: 120,
  },
] as GraphqlDatatableColumn[];
</script>

<template>
  <CompromissoGqlDatatable
    :columns="colunas"
    :show-status-search-bar="false"
    :show-dates-filter="false"
    :disabled-filters="[
      'codigo',
      'tipo',
      'fluxoDataInicio',
      'fluxoDataConclusao',
      'tipoFluxo',
      'fluxoCodigo',
      'pastaNome',
      'pastaGcpj',
      'pastaNumeroCnj',
      'responsavelProcessual',
      'estado',
    ]"
    :variables="{
      where: { tipo: { eq: 187 } },
      order: [{ dataInicio: 'DESC' }],
    }"
    :show-reload-button="true"
    :show-export-button="false"
  />
</template>
